<template>
    <div>
        <Header />
        <BannerProjects title="Projetos"/>
        <section class="furniture_area p_120" id="dlealp_section_projects">
            <div class="container">
                
                <div class="main_title">
                    <h2>Projetos recentes</h2>
                    <p>Estes são os projetos recentes realizados pela empresa. Clique na imagem para ter acesso ao portfólio completo.</p>
                </div>
                
                <div class="furniture_inner row">
                    
                    <div class="col-lg-4" v-for="project in projects">
                        <div class="furniture_item"> 
                            <a :href="`/projeto/${project.id}`">
                                <img class="img-fluid" :src="getFirstImageFromProject(project.id)" :alt="project.name">
                            </a>
                            <h4>{{project.name}}</h4>
                            <p>{{project.description}}</p>
                        </div>
                    </div>
                    
                </div>

                <div class="row wrap_pagination">
                    <div class="col-lg-12 pagination">
                        <nav aria-label="...">
                            <ul class="pagination">
                                <li v-if="pagination.current_page == 1" class="page-item disabled">
                                    <a href="#" class="page-link"> Retornar </a>
                                </li>
                                <li v-if="pagination.current_page > 1" class="page-item">
                                    <a href="#" @click="goToPage(pagination.prev_page_url)" class="page-link"> Retornar </a>
                                </li>

                                <li class="page-item disabled"><a href="#" class="page-link">Página</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">{{pagination.current_page}}</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">de</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">{{pagination.last_page}}</a></li>
                                
                                <li v-if="pagination.current_page == pagination.last_page" class="page-item disabled">
                                    <a href="#" class="page-link"> Avançar </a>
                                </li>

                                <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                                    <a href="#" @click="goToPage(pagination.next_page_url)" class="page-link"> Avançar </a>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </div>

            </div>
        </section>

        <Clients />

        <Footer />
        
    </div>
</template>

<script>
    import axios from 'axios';
    import Vue from 'vue';
    import SmoothScroll from 'smooth-scroll';
    import $ from 'jquery';

    import Header from '../components/header';
    import BannerProjects from '../components/banner_projects'; 

    import Clients from '../components/clients';
    import Footer from '../components/footer';

    import {apiURL} from '../resources/apiUrl';

    let axiosInstance = axios.create();

    export default {
        
        name: 'projects',

        data: function () {
            return {
                pagination: {},
                projects: [],
                imagesOfProjects: []
            }
        }, 
        
        components: {
            Header,
            BannerProjects,
            Clients,
            Footer
        },

        created() {

            axiosInstance.get(`${apiURL()}/lp/projects`)
                .then(response => {
                    this.pagination = response.data;
                    this.projects = response.data.data;
                    //Ao carregar projetos, busca imagens de cada um
                    this.projects.forEach(element => {
                        this.returnImagesFromProject(element.id);
                    });

                })
                .catch(error => {
                    console.log(error);
                })

        },

        mounted() {
            let nav_offset_top = $('header').height() + 50;
            if ( $('.header_area').length ){ 
                $(window).scroll(function() {
                    var scroll = $(window).scrollTop();   
                    if (scroll >= nav_offset_top ) {
                        $(".header_area").addClass("navbar_fixed");
                    } else {
                        $(".header_area").removeClass("navbar_fixed");
                    }
                })
            }
            let scroll = new SmoothScroll('a[href*="#"]');
            $('.nav a').on('click', function(){
                $('.navbar-toggler').click();
            });
        },

        methods: {
            
            returnImagesFromProject(id){
                axiosInstance.get(`${apiURL()}/lp/images/project/${id}`)
                    .then(response => {
                        this.imagesOfProjects.push(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            getFirstImageFromProject(projectId){

                let linkImage = null;

                this.imagesOfProjects.forEach( imageArray => {

                  imageArray.forEach( image => {
                      if(image.project.id == projectId) { 
                          if( linkImage == null ){
                              linkImage = image.link;
                          }
                      }
                  } );

                } );

                return `${apiURL()}/lp/images/${linkImage}`;
            },

            goToPage(url){
                axiosInstance.get(url)
                    .then(response => {
                        this.pagination = response.data;
                        this.projects = response.data.data;
                        //Ao carregar projetos, busca imagens de cada um
                        this.projects.forEach(element => {
                            this.returnImagesFromProject(element.id);
                        });

                    })
                    .catch(error => {
                        console.log(error);
                    })
            }

        }
    }
</script>

<style>
    .wrap_pagination {
        padding-top: 50px;
    }
    .pagination nav{
        margin-left: auto;
        margin-right: auto;
    }
</style>